import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from "../../utils";
import { Helmet } from "react-helmet";
import { adminRoutes } from '../../routes';

const PrivateRouter = () => {
    return (
        adminRoutes.map(({ path, Component, title }, key) => (
            <Route exact path={path} render={(props) =>
                isAuthenticated() && (localStorage.getItem('cms_type') === 'skill-up' || (path !== '/events' && path !== '/add-events' && path !== '/discourse-logs' && path !== '/account-activity' && path !== '/thought-leaders' && path !== '/groups' && path !== '/submissions'))
                    ? <>
                        {title &&
                            <Helmet>
                                <title>{title}</title>
                            </Helmet>
                        }
                        <Component {...props} />
                    </> : (isAuthenticated() ? <Redirect to='/users' /> : <Redirect to={{ pathname: '/', user: isAuthenticated, state: { from: props.location } }} />)
            } key={key} />
        ))
    )
};

export default PrivateRouter
